import React, { useEffect } from 'react';
import ApexCharts from 'apexcharts';

export default function Totaluser({ data, labels }) {
  useEffect(() => {
    const options = {
      series: [{ name: 'User Signups', data }],
      chart: { type: 'area', height: 250, zoom: { enabled: false } },
      dataLabels: { enabled: false },
      stroke: { curve: 'smooth', colors: ['#FFFFD9'] },
      fill: { type: 'gradient', gradient: { shadeIntensity: 1, type: 'vertical', gradientToColors: ['#3D37F100'], stops: [0, 100] } },
      title: { text: 'Total Users', align: 'left', style: { color: 'white' } },
      xaxis: { type: 'category', categories: labels, labels: { style: { colors: 'white' } }, axisBorder: { color: 'white' }, axisTicks: { color: 'white' } },
      yaxis: { labels: { style: { colors: 'white' } }, axisBorder: { color: 'white' }, axisTicks: { color: 'white' } },
      legend: { horizontalAlign: 'left', labels: { colors: 'white' } },
    };

    const chart = new ApexCharts(document.querySelector('#chart'), options);
    chart.render();

    return () => chart.destroy();
  }, [data, labels]);

  return (
    <div className='text-black text-center border border-[#ECEEF6] bg-[#1E1E1E] rounded-2xl px-5 py-3'>
      <div id="chart"></div>
    </div>
  );
}
